export default "__VITE_ASSET__ByoI0QDy__"